import { pathOr } from "ramda";

const getPublicProfileUrl = userName =>
  `https://www.instagram.com/${userName}/`;

const parseIGUserName = userName =>
  (userName.indexOf("@") === 0 ? userName.substring(1) : userName).trim();

const getProfileByUserName = userName => {
  const profileInfoUrl = getPublicProfileUrl(parseIGUserName(userName));
  return fetch(profileInfoUrl).then(res => {
    if (res.status === 429) {
      return { user: null, error: { type: "rate-limited" } };
    }
    if (res.status !== 200) {
      return null;
    }
    // via https://codelike.pro/fetch-instagram-posts-from-profile-without-__a-parameter/
    //     http://go-colly.org/articles/how_to_scrape_instagram/
    return res.text().then(htmlBody => {
      const sharedDataRegexp = /<script type="text\/javascript">window\._sharedData = (.*)<\/script>/;
      const json = JSON.parse(htmlBody.match(sharedDataRegexp)[1].slice(0, -1));
      const extractUser = pathOr({}, [
        "entry_data",
        "ProfilePage",
        "0",
        "graphql",
        "user"
      ]);
      return extractUser(json);
    });
  });
};

export default getProfileByUserName;
